module.exports = __webpack_public_path__ + "img/scene4.31cd5a5e.webp";